import React from "react";
import AdminShell from "@/pages/admin/AdminShell";
import FollowUpBoard from "@/components/FollowUpBoard";
import { useAuth } from "@/lib/auth";

/**
 * /follow-ups (admin-only route) — wraps FollowUpBoard in AdminShell so
 * the sidebar and top nav match the rest of the admin surface. Route is
 * `RequireRole roles={["admin"]}` in App.js precisely so marketing does
 * not land on an admin shell when they type the URL directly; marketing
 * consumes the same FollowUpBoard from MarketingDashboard's tab.
 *
 * Backfill CTA is gated by the real role (not effective view), which
 * matches the backend `require_roles("admin")` guard on the endpoint
 * itself. Belt-and-braces: the check is redundant here (only admins can
 * reach this route) but keeps the invariant local to the page in case
 * the guard above ever loosens.
 */
export default function FollowUpsPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  return (
    <AdminShell>
      <FollowUpBoard showBackfill={isAdmin} />
    </AdminShell>
  );
}
